import type { FbqQueueFn } from './types';

/**
 * Installs the Meta Pixel queue stub on `window.fbq` / `window._fbq`.
 * Makes no network request. A second call is a no-op and leaves any
 * already-queued arguments in place.
 *
 * @returns {void}
 */
export const installFbqStub = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.fbq === 'function') {
    return;
  }

  const fbq = function (...args: unknown[]) {
    if (typeof fbq.callMethod === 'function') {
      fbq.callMethod(...args);
      return;
    }
    fbq.queue.push(args);
  } as FbqQueueFn;

  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];

  window.fbq = fbq;
  window._fbq = fbq;
};
